import { useRef } from "react";

// Editable amount field. Mirrors the Hub .amount-wrap: a big gradient-clipped
// input that only accepts digits, sized to its content (width in ch). The whole
// wrap is a click target that focuses+selects the input (the input alone is a
// tiny transparent hit area), so a custom amount is always reachable. The parent
// owns the value and the sanitize/clamp logic. `symbol` is the player currency
// symbol supplied by the caller.
export default function AmountField({ label, value, onChange, maxLength, limits, inputId, symbol = "€" }) {
  const inputRef = useRef(null);
  const width = `${Math.max(String(value).length, 1)}ch`;
  const labId = inputId ? `${inputId}-lab` : undefined;

  // Clicking anywhere on the wrap (outside the input) focuses AND selects the
  // input. A direct click on the input is left to the browser so mid-number
  // caret placement keeps working.
  const handleWrapClick = (e) => {
    const el = inputRef.current;
    if (!el || e.target === el) return;
    el.focus();
    el.select();
  };

  return (
    <div className="amount-wrap" onClick={handleWrapClick}>
      <div className="lab" id={labId}>{label}</div>
      <div className="amount">
        <span className="cur">{symbol}</span>
        <input
          ref={inputRef}
          id={inputId}
          className="val"
          value={value}
          placeholder="0"
          inputMode="numeric"
          maxLength={maxLength}
          aria-label={label}
          aria-labelledby={labId}
          style={{ width }}
          onChange={(e) => onChange(e.target.value)}
        />
        <span className="car" />
      </div>
      <div className="limits">{limits}</div>
    </div>
  );
}
